import { useBoolean } from '@laxmimanogna/code-quick-components';
import React, { useContext, useEffect } from 'react';
import NotesActivityDrawer from './notes_activities/NotesActivityDrawer';
import { NoteIcon } from '../../../constants/IconData';
import { AuditSheetContext } from '../../../providers/AuditSheetProvider';

function NotesDrawer({
  onOpenNotes, 
  MyNotesActivity, 
  batchId = null, 
  tabType = undefined, 
  drawerRef, 
  ...props
}) {
  const [isOpenNotes, ionState] = useBoolean(false);
  const auditSheetContext = useContext(AuditSheetContext);

  useEffect(() => {
    if (drawerRef) drawerRef.current = ionState.on;
  }, []);

  return (
    <>
      <NoteIcon
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}
        onClick={() => {
          ionState.on()
          onOpenNotes()
        }}
        {...props}
      />
      {(!batchId || (batchId === auditSheetContext.commentFilters?.batchId && tabType === auditSheetContext.commentFilters?.tabType)) &&
       <NotesActivityDrawer 
       isOpen={isOpenNotes} 
       onClose={() =>  {
        ionState.off();
        auditSheetContext.setAllComments([]);
      }} 
       onOpenNotes={onOpenNotes} 
       argBatchId={batchId}/>}
    </>
  );
}

export default NotesDrawer;
